<template>
  <q-page class="flex-center">
    <div class="q-pa-md">
      <q-table
        title="Doadores"
        :data="$store.state.listUpload"
        :columns="columns"
        row-key="id"
        :visible-columns="visibleColumns"
        :pagination.sync="pagination"
        :filter="filter"
        :loading="$store.state.loading"
      >
        <template v-slot:top="props">
          <div class="col-4 q-table__title">Débito Itau</div>
          <div class="col-4 ">
            <q-input borderless dense debounce="300" input-class="inputSearch" v-model="filter" placeholder="Buscar">
              <template v-slot:append>
                <q-icon class="text-white" name="search"></q-icon>
              </template>
            </q-input>
          </div>
          <div class="col-3 ">
            <q-select
              v-model="visibleColumns"
              multiple
              borderless
              dense
              options-dense
              emit-value
              map-options
              :display-value="'Colunas visíveis'"
              :options="columns"
              option-value="name"
              style="min-width: 150px"
            ></q-select>
          </div>
          <div class="col-1 ">
            <q-btn color="bg-purple-10" outline icon="add" @click="openDialog = true"></q-btn>
          </div>

        </template>

        <template v-slot:body-cell-boleto_dda="value">
          <q-td>
            <q-chip square color="teal" text-color="white" v-if="value.value == '1'" label="Sim"/>
            <q-chip square color="yellow-5" text-color="black" v-if="value.value == '0' || value.value == ''"
                    label="Não"/>
          </q-td>
        </template>
        <template v-slot:body-cell-options="value">
          <q-td>
            <q-btn round color="primary" icon="visibility">
            </q-btn>
          </q-td>
        </template>

      </q-table>

    </div>
    <q-dialog
      v-model="openDialog"
      transition-show="slide-up"
      transition-hide="slide-down"
      :maximized="maximizedToggle"
      content-style="{ backgroundColor: '#590A7F' }"
    >
      <q-card class="bg-purple-10 text-white">

        <q-card-section>
          <q-uploader
            :url="url"
            label="Arquivo de retorno de debito itaú"
            :factory="uploadFactory"
            color="purple-10"
            accept=".RET"
            send-raw
            :auto-upload="true"
            @uploaded="finished"
            @finish="finished"
          >

          </q-uploader>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="alertError">
      <q-card style="width: 300px">
        <q-card-section>
          <div class="text-h6">{{titleError}}</div>
        </q-card-section>

        <q-card-section>
          {{messageError}}
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" @click="alertError = false"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>

</template>

<script>
import { UPLOAD_DEBITO_ITAU } from '../graphql/graphql'

export default {
  name: 'UploadItauBoleto',
  data () {
    return {
      openDialog: false,
      alertError: false,
      titleError: '',
      messageError: '',
      filter: '',
      data: [],
      url: '',
      maximizedToggle: false,
      visibleColumns: [
        'codigo_banco',
        'numero_registro',
        'agencia',
        'banco',
        'dac',
        'seu_numero',
        'nosso_numero',
        'data_agendada',
        'valor_agendado',
        'data_cobrada',
        'valor_cobrado',
        'numero_inscricao',
        'nome',
        'nota'
      ],
      loading: true,
      columns:
                    [
                      {
                        name: 'codigo_banco',
                        label: 'Código do banco',
                        align: 'left',
                        field: 'codigo_banco'
                      }, {
                        name: 'codigo_lote',
                        label: 'Código do lote',
                        align: 'left',
                        field: 'codigo_lote'
                      }, {
                        name: 'numero_registro',
                        label: 'Número do registro',
                        align: 'left',
                        field: 'numero_registro'
                      }, {
                        name: 'segmento',
                        label: 'Segmento',
                        align: 'left',
                        field: 'segmento'
                      }, {
                        name: 'codigo',
                        label: 'Código',
                        align: 'left',
                        field: 'codigo'
                      }, {
                        name: 'compensacao',
                        label: 'Compensação',
                        align: 'left',
                        field: 'compensacao'
                      }, {
                        name: 'banco',
                        label: 'Banco',
                        align: 'left',
                        field: 'banco'
                      }, {
                        name: 'zero1',
                        label: 'Zero 1',
                        align: 'left',
                        field: 'zero1'
                      }, {
                        name: 'agencia',
                        label: 'Agência',
                        align: 'left',
                        field: 'agencia'
                      }, {
                        name: 'branco1',
                        label: 'Branco 1',
                        align: 'left',
                        field: 'branco1'
                      }, {
                        name: 'zeros2',
                        label: 'Zeros 2',
                        align: 'left',
                        field: 'zeros2'
                      }, {
                        name: 'conta',
                        label: 'Conta',
                        align: 'left',
                        field: 'conta'
                      }, {
                        name: 'branco2',
                        label: 'Branco 2',
                        align: 'left',
                        field: 'branco2'
                      }, {
                        name: 'dac',
                        label: 'DAC',
                        align: 'left',
                        field: 'dac'
                      }, {
                        name: 'nome',
                        label: 'Nome',
                        align: 'left',
                        field: 'nome'
                      }, {
                        name: 'seu_numero',
                        label: 'Seu número',
                        align: 'left',
                        field: 'seu_numero'
                      }, {
                        name: 'branco3',
                        label: 'Branco 3',
                        align: 'left',
                        field: 'branco3'
                      }, {
                        name: 'data_agendada',
                        label: 'Data agendada',
                        align: 'left',
                        field: 'data_agendada'
                      }, {
                        name: 'tipo',
                        label: 'Tipo da moeda',
                        align: 'left',
                        field: 'tipo'
                      }, {
                        name: 'quantidade',
                        label: 'Quantidade',
                        align: 'left',
                        field: 'quantidade'
                      }, {
                        name: 'valor_agendado',
                        label: 'Valor agendado',
                        align: 'left',
                        field: 'valor_agendado'
                      }, {
                        name: 'nosso_numero',
                        label: 'Nosso número',
                        align: 'left',
                        field: 'nosso_numero'
                      }, {
                        name: 'data_cobrada',
                        label: 'Data cobrada',
                        align: 'left',
                        field: 'data_cobrada'
                      }, {
                        name: 'valor_cobrado',
                        label: 'Valor cobrado',
                        align: 'left',
                        field: 'valor_cobrado'
                      }, {
                        name: 'tipo_mora',
                        label: 'Tipo mora',
                        align: 'left',
                        field: 'tipo_mora'
                      }, {
                        name: 'valor_mora',
                        label: 'valor mora',
                        align: 'left',
                        field: 'valor_mora'
                      }, {
                        name: 'complemento',
                        label: 'Complemento',
                        align: 'left',
                        field: 'complemento'
                      }, {
                        name: 'branco4',
                        label: 'Branco 4',
                        align: 'left',
                        field: 'branco4'
                      }, {
                        name: 'numero_inscricao',
                        label: 'CPF/CNPJ',
                        align: 'left',
                        field: 'numero_inscricao'
                      }, {
                        name: 'ocorrencias',
                        label: 'ocorrencias',
                        align: 'left',
                        field: 'ocorrencias'
                      }, {
                        name: 'nota',
                        label: 'Nota',
                        align: 'left',
                        field: 'nota'
                      }
                    ],
      pagination:
                    {
                      sortBy: 'name',
                      descending:
                            false,
                      page:
                            1,
                      rowsPerPage:
                            0
                    }

    }
  },
  methods: {
    uploadFactory (file) {
      this.$store.dispatch('setLoading')
      return (

        this.$apollo.mutate({
          mutation: UPLOAD_DEBITO_ITAU,
          variables: { file: file[0] },
          context: {
            hasUpload: true
          },
          update: (store, data) => {
            this.$store.dispatch('toList', data.data.uploadDebitoItau)
            this.pagination.rowsNumber = data.data.uploadDebitoItau.length
          }
        })
          .catch(error => {
            const errors = { error }
            this.alertError = true
            this.titleError = errors.error.graphQLErrors[0].message
            this.messageError = errors.error.graphQLErrors[0].debugMessage
            console.error(errors.error.graphQLErrors[0].trace[0])
          })

      )
      // return new Promise(resolve, reject);
    },
    finished () {
      this.$store.dispatch('setLoading')
      this.openDialog = false
    }
  },
  mounted () {
    this.$store.dispatch('toList', [])
  }
}
</script>
<style>
  input[type='text'].inputSearch {
    color: white !important;
  }
</style>
